// 介錯の突き当て (exec_maulJab) の入りと戻りに、段の絵を新しく描いて足した版 (2026-10-28・剣舞の作りを他のボスへ)。
//   配布版は下の出だしを2段にした版 1028e (10-28)。ここから順に 1028 → 1028b → 1028c → 1028d → 1028e と直した。
//   前の配布版は 待機 → 溜め (jab_coil) → 刺し (jab_lunge) → 待機 を1枚ずつ替える。刃を垂らした立ち姿から、脚を開き刃を水平に構える姿へ
//   1コマで替わるので「ガクッ」と見える。剣舞の連 (src/blade_dancer_arle.ts) と同じく、段を踏んで入り、段を踏んで戻る。
//     入り: 待機 → 立ったまま刃を上げ始める (jab_return_2) → 腰を落とし刃が床から約60度 (jab_sink_1) → 溜め
//     戻り: 刺し → 刃を引き戻す (jab_return_1) → 立ち姿の手前 (jab_return_2) → 待機
//   段の替わり目だけ短く溶かす (withDissolves・最大 60ms)。溜め→刺しの替わり目は今のまま切り替え。
//   絵は Codex に溜めの絵と同じ背丈・画風で描かせた (票 exec-jab-steps-1028・原画 そざい/bosses/the-executioner/2026-10-28-jab-steps/)。
//   既存の別の絵を挟む形は 10-28 に作者が退けた (腕の向き・大きさが合わない)。jab_sink_2 は溜めより深く沈むので使っていない。
//   秒数・判定・tag は前の配布版のまま＝描画だけ。1028 は開発版の ?execJabSteps=1028 でだけ入る。
//   記録 = docs/research/2026-10-28-blade-dancer-construction-for-other-bosses.md
import { BOSS_ATTACK_TIMELINES, EXEC_JAB_TIMELINE_VARIANTS, type BossAttackTimeline } from './boss_pose_timeline'
import { withDissolves, type SoftKey } from './blade_dancer_art'
import { setExecJabLinkTimeline, setExecJabSwellOff, setExecJabTrembleOff } from './exec_jab_tremble_1028'

// 配布版の突き当ての秒数 (boss_pose_timeline.ts の exec_maulJab: 溜め 650・攻撃 130・戻り 620)。溶かしの長さの計算に使う。
const PHASE_MS = { telegraph: 650, active: 130, recovery: 620 }

export const EXEC_JAB_TIMELINE_STEPS_1028: BossAttackTimeline = withDissolves([
  { phase: 'telegraph', at: 0.0, image: 'idle', hold: true, soft: true },
  { phase: 'telegraph', at: 0.08, image: 'jab_return_2', hold: true, soft: true },
  { phase: 'telegraph', at: 0.17, image: 'jab_sink_1', hold: true, offset: { x: -6 }, soft: true },
  // 溜めは止めて長く見せ、終わり際に少し引いて力を溜める (剣舞の TENSE と同じ考え・伸び縮みはしない)
  { phase: 'telegraph', at: 0.27, image: 'jab_coil', hold: true, tag: 'anticipation', ease: 'easeIn', offset: { x: -14 } },
  { phase: 'telegraph', at: 0.9, image: 'jab_coil', hold: true, offset: { x: -20 } },
  { phase: 'active', at: 0.0, image: 'jab_coil', hold: true, ease: 'easeOut', offset: { x: -20 } },
  { phase: 'active', at: 0.35, image: 'jab_lunge', hold: true, tag: 'contact', offset: { x: 20 } },
  { phase: 'recovery', at: 0.0, image: 'jab_lunge', hold: true, offset: { x: 20 } },
  { phase: 'recovery', at: 0.2, image: 'jab_lunge', hold: true, ease: 'easeIn', offset: { x: 20 }, soft: true },
  { phase: 'recovery', at: 0.32, image: 'jab_return_1', hold: true, ease: 'easeOut', offset: { x: 10 }, soft: true },
  { phase: 'recovery', at: 0.46, image: 'jab_return_2', hold: true, soft: true },
  { phase: 'recovery', at: 0.6, image: 'idle', hold: true },
], PHASE_MS)

// 一歩先の版 (?execJabSteps=1028b・10-28 作者「前より滑らかになっている。さらにできる？」「剣舞の３連の１撃目の溜めから振り下ろしにかけての作りがこのゲームの中で一番キレイ」)。
//   絵は 1028 と同じ。剣舞の三連の1撃目を測って分かった3つを、位置と傾きだけで足した (記録 docs/research/2026-10-28-blade-waltz-first-strike-measure.md)。
//     ①溜めの間も止めない: 剣舞は掲げ切った絵の 250ms の間に 8px 伸び上がり続ける。介錯は 470ms ほぼ止まっていた
//       → 刃を引き、腰を沈め、少し反る (ゆっくり始めて終わりへ向けて深く)。
//     ②体が絵より先に出る: 剣舞は掲げ切った絵のまま最後の 100ms で 70px 前へ滑り出し、踏み出す絵で減速する。
//       → 溜めの最後の 80ms で、溜めの絵のまま前へ動き出す (だんだん速く)。
//     ③刺した所で減速して止まる: 剣舞は踏み出す絵で減速しきってから当たる絵へ替わり、当たる絵の間は動かない。
//       介錯は刺しの絵のまま等速で 44px 進み、止まる1コマで急に止まっていた
//       → 刺しの絵の前半で減速しきり、後半は止める (体の移動 lungeDistance は配布版のまま。絵のずらしで見た目だけ減速させる)。
//   刺しの絵が体より前へ出るのは最大 37px (攻撃の半ば・1028 は 20px)。攻撃の終わりで 1028 と同じ 20px に戻る (当たりは体の位置から測る)。
const TELEGRAPH_1028B: SoftKey[] = [
  { phase: 'telegraph', at: 0.0, image: 'idle', hold: true, soft: true },
  { phase: 'telegraph', at: 0.08, image: 'jab_return_2', hold: true, soft: true },
  { phase: 'telegraph', at: 0.17, image: 'jab_sink_1', hold: true, offset: { x: -6 }, soft: true },
  { phase: 'telegraph', at: 0.27, image: 'jab_coil', hold: true, tag: 'anticipation', ease: 'easeOut', offset: { x: -8 } },
  { phase: 'telegraph', at: 0.55, image: 'jab_coil', hold: true, ease: 'easeIn', offset: { x: -10, y: 3 }, rot: -1 },
  { phase: 'telegraph', at: 0.88, image: 'jab_coil', hold: true, ease: 'easeIn', offset: { x: -12, y: 6 }, rot: -1.5 },
  { phase: 'active', at: 0.0, image: 'jab_coil', hold: true, ease: 'easeIn', offset: { x: -2, y: 2 }, rot: -1 },
  // 体は攻撃の間ずっと等速で進む (0.34px/ms)。絵のずらしを前半で足して後半で戻し、見た目を 前半速く → 後半ほぼ止まる にする。
  { phase: 'active', at: 0.25, image: 'jab_lunge', hold: true, tag: 'contact', ease: 'easeOut', offset: { x: 30 } },
  { phase: 'active', at: 0.5, image: 'jab_lunge', hold: true, offset: { x: 37 } },
  // 段をまたぐ補間は間の段 (comboGap) の分だけ遅れるので、攻撃の終わりに置いて戻り切る (置かないと戻りの1コマ目で 8px 後ろへ飛ぶ)
  { phase: 'active', at: 0.98, image: 'jab_lunge', hold: true, offset: { x: 21 } },
]
export const EXEC_JAB_TIMELINE_STEPS_1028B: BossAttackTimeline = withDissolves([
  ...TELEGRAPH_1028B,
  { phase: 'recovery', at: 0.0, image: 'jab_lunge', hold: true, offset: { x: 20 } },
  { phase: 'recovery', at: 0.2, image: 'jab_lunge', hold: true, ease: 'easeIn', offset: { x: 20 }, soft: true },
  { phase: 'recovery', at: 0.32, image: 'jab_return_1', hold: true, ease: 'easeOut', offset: { x: 10 }, soft: true },
  { phase: 'recovery', at: 0.46, image: 'jab_return_2', hold: true, soft: true },
  { phase: 'recovery', at: 0.6, image: 'idle', hold: true },
], PHASE_MS)

// 震えを切った版 (?execJabSteps=1028c・10-28 作者「突きあてがちょっと震えてる？というかちらついてる感じがある」)。
//   並びは 1028b のまま。溜めの間に全ボス共通で足す乱数の微振動 (sprites.ts の trembleAmp・最大 ±0.6 単位) を、突き当てでだけ切る。
//   乱数は描くたびに変わるので、1028b のじわっと引く・沈む・反る動きの上で体が細かく行ったり来たりして見えていた。
//   溜めの膨らみ (最大 5%) は決まった動きなので残す。花嫁の分岐予告と同じ考え (「乱数は意図に読めず、等速の引きを濁らせる」)。

// 踏み込みの版 (?execJabSteps=1028d・10-28 作者「前に突き出しながらなんか氷の上をツルツル滑ってるみたいになってる」
//   「床を滑っているから踏み込んでいるようにしてほしい」「突き当てを出す前に、一瞬半透明の影を前に出していると思う…ちらついているように見えていた」)。
//   1028c を毎コマ撮って両足の位置を測った (scripts/capture_exec_jab_step_1028.mjs)。滑りの元は2つ:
//     ①溜めの最後 80ms に溜めの絵のまま前へ 25px 動く (1028b の「体が絵より先に出る」)。
//     ②刺しの絵の間も体 (lungeDistance 44px・等速) と一緒に絵が前へ 22px 動く。どちらも足が床の上を滑る。
//   さらに溜め→刺しの替わり目で、絵が 前 → 6px 後ろ → 前 と行き来していた (段をまたぐ補間)。重ねて描く絵は無い。
//   直し方: 絵が出ている間は足を床に留め、動くのは絵の替わり目だけにする。どの絵も「片足を留め、もう片足を動かす」。
//     入り (後ろ足を留める): 待機 → 戻り2 (前足を寄せる) → 沈み1 (前足を大きく出す) → 溜め
//     刺し (後ろ足を留める): 溜め → 刺し。刺しの間は体が 44px 進む分を絵のずらしで打ち消す (体の速さ 44px/攻撃と同じ傾き)。
//     戻り: 刺し → 戻り1 (腰を刺しの腰の近くに留め、両足を少し寄せる) → 戻り2 (前足を留め、後ろ足を寄せる) → 待機 (後ろ足を留める)
//   ずらしは絵の足の位置 (原画px・透明度の下端 4%) と倍率 1.2 (=0.1717px/原画px) から逆算した。足を留めるキーは ease 'step'
//   (次の絵のずらしへ補間しない)。溜めの間の沈みと反り (y と傾き) は 1028b のまま、震えは 1028c と同じく切り、溜めの膨らみ (5%) も切る (足が外へ滑り、攻撃の頭で刃が跳ねる元)。
//   体の位置・当たり・秒数は配布版のまま＝描画だけ。刃先の見た目は 1028c より前へ出る (刺しの絵の後ろ足が溜めの後ろ足に残るため)。
const JAB_D_COIL_X = -7.6
export const EXEC_JAB_TIMELINE_STEPS_1028D: BossAttackTimeline = [
  { phase: 'telegraph', at: 0.0, image: 'idle', hold: true, ease: 'step' },
  { phase: 'telegraph', at: 0.08, image: 'jab_return_2', hold: true, ease: 'step', offset: { x: -32.2 } },
  { phase: 'telegraph', at: 0.17, image: 'jab_sink_1', hold: true, ease: 'step', offset: { x: -3 } },
  { phase: 'telegraph', at: 0.27, image: 'jab_coil', hold: true, tag: 'anticipation', ease: 'easeOut', offset: { x: JAB_D_COIL_X } },
  { phase: 'telegraph', at: 0.55, image: 'jab_coil', hold: true, ease: 'easeIn', offset: { x: JAB_D_COIL_X, y: 3 }, rot: -1 },
  { phase: 'telegraph', at: 0.88, image: 'jab_coil', hold: true, ease: 'easeIn', offset: { x: JAB_D_COIL_X, y: 6 }, rot: -1.5 },
  { phase: 'active', at: 0.0, image: 'jab_coil', hold: true, ease: 'linear', offset: { x: JAB_D_COIL_X, y: 6 }, rot: -1.5 },
  // 溜めの終わりの沈みと反りを攻撃の頭でも保つ (1028b は攻撃の頭で y 6→2・傾き −1.5→−1 へ戻し、刃が 9.6px 後ろへ跳ねていた)。
  // 攻撃の頭は体がもう進み始めているので、溜めの絵も同じだけ戻して床に留める (0.249 で体は 11px 進む)。
  { phase: 'active', at: 0.249, image: 'jab_coil', hold: true, ease: 'step', offset: { x: JAB_D_COIL_X - 11, y: 6 }, rot: -1.5 },
  // 体は攻撃の間 44px を等速で進む。ずらしを同じ速さで減らして、刺しの絵を床に留める (後ろ足が溜めの後ろ足の所)。
  { phase: 'active', at: 0.25, image: 'jab_lunge', hold: true, tag: 'contact', ease: 'linear', offset: { x: 73.9 } },
  { phase: 'active', at: 0.98, image: 'jab_lunge', hold: true, ease: 'linear', offset: { x: 41.8 } },
  { phase: 'recovery', at: 0.0, image: 'jab_lunge', hold: true, ease: 'step', offset: { x: 40.9 } },
  { phase: 'recovery', at: 0.32, image: 'jab_return_1', hold: true, ease: 'step', offset: { x: -31.7 } },  // 腰を刺しの腰に寄せる (後ろ足を留めると腰が 21px 戻ってから出直し、軸が下がって見えた・10-28)
  { phase: 'recovery', at: 0.46, image: 'jab_return_2', hold: true, ease: 'step', offset: { x: -28.5 } },
  { phase: 'recovery', at: 0.6, image: 'idle', hold: true, ease: 'step' },
]

// 出だしを2段にした版 1028e (10-28)。1028d の入りは 175ms に絵を4枚 (待機・戻り2・沈み1・溜め) 替え、1枚 3〜4コマで
//   刃の向きが大きく跳ぶので、作者の目には「ぱらぱらとちらつく」と映った (設計どおりに動いていてバグではない)。
//   沈み1 は溜めとほぼ同じ形で1枚分の働きをしていないので外し、刃を上げ始める絵 (戻り2) を 8コマ見せてから溜めへ入る。
//   足を留めるずらしと、溜めから後ろは 1028d のまま。
export const EXEC_JAB_TIMELINE_STEPS_1028E: BossAttackTimeline = [
  { phase: 'telegraph', at: 0.0, image: 'idle', hold: true, ease: 'step' },
  { phase: 'telegraph', at: 0.06, image: 'jab_return_2', hold: true, ease: 'step', offset: { x: -32.2 } },
  ...EXEC_JAB_TIMELINE_STEPS_1028D.filter(k => !(k.phase === 'telegraph' && k.at < 0.27)),
]

// 配布版の既定は出だしを2段にした版 1028e (10-28 作者「最新のでいい」＋踏み込みと影の直し＋出だしのちらつきの直し)。前の配布版は開発版 ?execJabSteps=old。
//   ?jabArt= (09-04 の絵の候補) と並べる時は &execJabSteps=old を添える (付けないと 1028e が上書きする)。
// 連の2拍目以降 (src/exec_jab_tremble_1028.ts の execJabLinkTimeline)。入りの段を飛ばし、溜めの絵から入る。ほかは 1028d・1028e と同じ。
export const EXEC_JAB_TIMELINE_STEPS_1028D_LINK: BossAttackTimeline = [
  { phase: 'telegraph', at: 0.0, image: 'jab_coil', hold: true, tag: 'anticipation', ease: 'easeOut', offset: { x: JAB_D_COIL_X } },
  ...EXEC_JAB_TIMELINE_STEPS_1028D.filter(k => !(k.phase === 'telegraph' && k.at < 0.5)),
]

type JabStepsMode = 'old' | '1028' | '1028b' | '1028c' | '1028d' | '1028e'
let mode: JabStepsMode = '1028e'
export function execJabStepsMode(): JabStepsMode { return mode }
function apply(): void {
  const planted = mode === '1028d' || mode === '1028e'
  setExecJabTrembleOff(mode === '1028c' || planted)
  setExecJabSwellOff(planted)
  setExecJabLinkTimeline(planted ? EXEC_JAB_TIMELINE_STEPS_1028D_LINK : null)
  if (mode === 'old') return
  BOSS_ATTACK_TIMELINES['the-executioner']!.exec_maulJab = mode === '1028' ? EXEC_JAB_TIMELINE_STEPS_1028
    : mode === '1028d' ? EXEC_JAB_TIMELINE_STEPS_1028D : mode === '1028e' ? EXEC_JAB_TIMELINE_STEPS_1028E : EXEC_JAB_TIMELINE_STEPS_1028B
}
// 読み込んだ時点で既定を入れる (game.ts を通らないラボ・テストでも配布版と同じ並びにする)。
apply()
export function setExecJabSteps(raw: string | null): void {
  const dev = import.meta.env.DEV && (raw === 'old' || raw === '1028' || raw === '1028b' || raw === '1028c' || raw === '1028d' || raw === '1028e')
  mode = dev ? raw : '1028e'
  // old は段の版が入っている時だけ前の配布版 (lunge) へ戻す (?jabArt= で選んだ絵の候補は残す)。
  const tls = BOSS_ATTACK_TIMELINES['the-executioner']!
  const stepped = [EXEC_JAB_TIMELINE_STEPS_1028, EXEC_JAB_TIMELINE_STEPS_1028B, EXEC_JAB_TIMELINE_STEPS_1028D, EXEC_JAB_TIMELINE_STEPS_1028E]
  if (mode === 'old' && tls.exec_maulJab && stepped.includes(tls.exec_maulJab)) tls.exec_maulJab = EXEC_JAB_TIMELINE_VARIANTS.lunge
  apply()
}
